import { Attachment } from '../attachment/attachment';
import { Campaign } from '../campaign/campaign';

export class PartnerPageCategory {
  category: PartnerCategory;
  partners: Partner[];
}

export class Partner {
  partnerName: string;
  description: string;
  micrositeSlug?: string;
  order?: number;
  partnerLogoAttachment?: Attachment;
  moreCampaigns: boolean;
  campaigns?: PartnerCampaign[];
}

export class PartnerCampaign extends Campaign {
  campaignName: string;
}

export enum PartnerCategory {
  AcceleratorsAndIncubators = 1,
  AngelInvestors = 2,
  IndustryPartners = 3,
  Universities = 4,
  VentureCapitalFirms = 5,
}

export class SimplePartner {
  partnerName: string;
  description: string;
  micrositeSlug?: string;
  category: PartnerCategory;
}
